export const defaultUserData = {
  isAdmin: false,
};

export const writePermissions = ['owner', 'write'];

export const ownerPermissions = ['owner'];
